module.exports = __webpack_public_path__ + "static/media/trading-services-img1.8a82439a.jpg";